var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassTooltip",
    {
      attrs: {
        placement: "bottom-end",
        arrow: "",
        disabled: _vm.current < _vm.max,
        "content-class": "card-counter-tooltip"
      }
    },
    [
      _c("template", { slot: "content" }, [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$l10n.__(
                "Vous devez masquer des cartes pour en afficher de nouvelles"
              )
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "card-counter br m-0",
          class: { "alert-05-bkg": _vm.current >= _vm.max }
        },
        [
          _c("span", { ref: "count", staticClass: "fs-3 lh-20" }, [
            _c("span", { staticClass: "bold" }, [_vm._v(_vm._s(_vm.current))]),
            _vm._v(" / " + _vm._s(_vm.max) + "\n        ")
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "fs-2" }, [
            _vm._v(_vm._s(_vm.$l10n.__("cartes maximum")))
          ])
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }